//正则
//校验手机号
const CheckNumber = function (num) {
    let check = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
    if (check.test(num)) {
        return false
    } else {
        return true
    }
}
//校验身份证
const CheckId = function (id) {
    let check = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (check.test(id)) {
        return false
    } else {
        return true
    }
}
//校验邮箱
const CheckEmail = function (email) {
    let check = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    if (check.test(email)) {
        return false
    } else {
        return true
    }
}
//正则

//地址脱敏
const AddressReplace = function(address) {
      if (typeof address !== "string" || address.length <= 5) {
        return address;
      }
      let length = address.length;
      let keepCount = 5; // 保留最后5个字符
      let replaceStart = Math.max(0, length - 9);
      let replaceEnd = length - 5;
      if (replaceEnd <= replaceStart) {
        return address.slice(-keepCount);
      }
      let replaceCount = replaceEnd - replaceStart;
      let stars = "*".repeat(replaceCount);
      return (
        address.substring(0, replaceStart) +
        stars +
        address.substring(length - keepCount)
      );
    }

    //姓名脱敏
    const NameReplace = function(name, replaceChar = "*") {
      if (typeof name !== "string") return name || "";
      let str = name.trim();
      str = str.replace(/\s/g, "");
      let len = str.length;
      if (len <= 1) return str;
      if (len === 2) return replaceChar + str[1];
      if (len === 3) return str[0] + replaceChar + str[2];
      if (len === 4) return str.substring(0, 2) + replaceChar.repeat(2);
      // 5个及以上
      return str.substring(0, 3) + replaceChar.repeat(2) + str.substring(5);
    }

export { CheckNumber, CheckId, CheckEmail ,AddressReplace,NameReplace}